import React from "react";
import {
  ImagePreview as StyledImagePreview,
  ImagePreviewContainer,
} from "./ImagePreview.styles";

export default function ImagePreview({ displayImage }) {
  return (
    <ImagePreviewContainer>
      <StyledImagePreview src={displayImage} />
    </ImagePreviewContainer>
  );
}
